import $ from 'jquery';
import * as sliderFunctions from "../slider";
import * as productSlider from "./slider";
import * as header from '../header';
import * as productFeature from '../product_feature';
import * as swatches from './swatches';

function reinitAllFunction() {
  sliderFunctions.default();
  productSlider.default();
  header.default();
  productFeature.default();
  //swatches.default();
}

function changeProduct (evt) {
  let $currentUrl = evt.target.value;
  let selectors = {
    reviews: '.review-carousel__heading-review',
    reviewsSection: '.review-carousel__real-reviews',
    productMainImages: '.product-main__left',
    productLogoSlider: '.product-main__right .logo_slider',
    headingWrapper: '.product-main__right .product-top-info__heading-wrapper',
    stickyBottom: '.sticky-bottom-wrapper',
    stickyButton: '.sticky-bottom--button',
    form: '.product-main__right .product-form--bundle',
    feature_section: '.product-feature',
    product_video: '#product-video',
    product_info: '.product-main__right .faq-main',
    paymentTherms: '.product-payment-terms',
    amazonBTN: '#amzn-buy-now'
  }

  const selectorsValues = Object.values(selectors);

  $.ajax({
    url: $currentUrl,
    method: 'GET',
    success: function (data) {
      $.each(selectorsValues, function (index, item) {
            const dataBlock = $(data).find(item);
            (dataBlock.length) ? $(item).replaceWith(dataBlock).fadeIn() : $(item).fadeOut()
          }
      )},
    complete: function (data) {
      $("#addToCartForm .product-add-to-cart").data("top", $("#addToCartForm .product-add-to-cart").offset().top); //for index.js
      reinitAllFunction();
      customFetch();
    }
  })
}

function customFetch() {
  let prime_widget_elem = document.getElementById('amzn-buy-now').getAttribute('data-sku');
  if(bwp) {
    bwp.updateWidget(`${prime_widget_elem}`)
  }
}



export default function() {
  $('.product-switcher input[type=radio]').on('change', (evt) => {
    changeProduct(evt);
 })
}